import { render, staticRenderFns } from "./passRejectRefuse.vue?vue&type=template&id=3c5e31da&scoped=true"
import script from "./passRejectRefuse.vue?vue&type=script&lang=js"
export * from "./passRejectRefuse.vue?vue&type=script&lang=js"
import style0 from "./passRejectRefuse.vue?vue&type=style&index=0&id=3c5e31da&prod&scoped=true&lang=css"
import style1 from "./passRejectRefuse.vue?vue&type=style&index=1&id=3c5e31da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e31da",
  null
  
)

export default component.exports